import sectionFaq from './template-parts/section-faq';
import sectionApplications from './template-parts/section-applications';
import sectionVideoPlayer from './template-parts/section-video-player';
import pageHeaderHumbotron from "./page-header/page-header-humbotron";
jQuery(document).ready(function () {

	(function ($) {

		pageHeaderHumbotron();
		sectionFaq();
		sectionApplications();
		sectionVideoPlayer();

		/* Number animation */
		if ($('.number-animation').length) {
			$('.number-animation').fadeTo('fast', 0);
			$(window).scroll(scrollTrigger);
			var viewed = false;
		}

		function isScrolledIntoView(elem) {
			var docViewTop = $(window).scrollTop();
			var docViewBottom = docViewTop + $(window).height();
			var elemTop = $(elem).offset().top;
			var elemBottom = elemTop + 200/* $(elem).height() */;
			return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop))
		}

		function scrollTrigger() {
			setTimeout(function () {
				if (isScrolledIntoView($(".number-anim-wrapper")) && !viewed) {
					viewed = true;
					console.log("viewed");
					$('.number-animation').each(function () {
						$(this).fadeTo('slow', 1);
					});
					$('.number-anim-no').each(function () {
						$(this).prop('Counter', 0).show().animate({
							Counter: $(this).text()
						}, {
							duration: 2000, easing: 'swing', step: function (now) {
								$(this).text(Math.ceil(now));
							}
						});
					});
				}
			}, 500);
		}

	})(jQuery);

});

import './aptumistic/slide';
